import { useEffect, useState } from "react";
import { Badge } from "react-bootstrap";

import ContainerAnimation from "components/ContainerAnimation";
import { useProfessionalQuote } from "providers/Quote/ProfessionalQuote";
import { SearchDataQuoteProfessional } from "types/quotes";

import ProfessionalFinishedQuoteList from "./components/ProfessionalFinishedQuoteList";
import ProfessionalPendingQuoteList from "./components/ProfessionalPendingQuoteList";
import ProfessionalQuotesSearch from "./components/ProfessionalQuoteSearch";

const ProfessionalQuote = () => {
  const {
    professionalPendingQuotesTotal,
    professionalPendingQuotesFoundTotal,
    professionalFinishedQuotesTotal,
    professionalFinishedQuotesFoundTotal,
    searchData,
    setSearchData,
  } = useProfessionalQuote();

  useEffect(() => {
    return () => {
      setSearchData({} as SearchDataQuoteProfessional);
    };
  }, []);

  const [selectedNavTab, setSelectedNavTab] = useState("pending-data");

  const handleTabClick = (e: React.MouseEvent<HTMLSpanElement>) => {
    setSelectedNavTab(e.currentTarget.id);
  };

  const handleTabKeyDown = (e: React.KeyboardEvent<HTMLSpanElement>) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      setSelectedNavTab((e.currentTarget as HTMLSpanElement).id);
    }
  };

  return (
    <ContainerAnimation className="content">
      {/* Título e Pesquisa */}
      <div className="bg-white">
        <div className="container">
          <div className="row justify-content-between align-items-center">
            <div className="col-12 col-md-auto">
              <h1>Orçamentos</h1>
            </div>
            <div className="col-12 col-md-auto">
              <ProfessionalQuotesSearch />
            </div>
            <div className="col-12">
              <ul className="nav nav-tabs" role="tablist">
                <li className="nav-item" role="presentation">
                  <span
                    id="pending-data"
                    role="tab"
                    tabIndex={0}
                    aria-selected={selectedNavTab === "pending-data"}
                    aria-controls="pending-data-panel"
                    className={`nav-link link-primary ${
                      selectedNavTab === "pending-data" && "active"
                    }`}
                    onClick={handleTabClick}
                    onKeyDown={handleTabKeyDown}
                    style={{ cursor: "pointer" }}
                  >
                    Pendentes
                    <Badge bg="primary" className="ms-1 text-white">
                      {!Object.values(searchData).some(
                        (currentValue) => !!currentValue
                      )
                        ? professionalPendingQuotesTotal
                        : professionalPendingQuotesFoundTotal}
                    </Badge>
                  </span>
                </li>

                <li className="nav-item" role="presentation">
                  <span
                    id="finished-data"
                    role="tab"
                    tabIndex={0}
                    aria-selected={selectedNavTab === "finished-data"}
                    aria-controls="finished-data-panel"
                    className={`nav-link link-primary ${
                      selectedNavTab === "finished-data" && "active"
                    }`}
                    onClick={handleTabClick}
                    onKeyDown={handleTabKeyDown}
                    style={{ cursor: "pointer" }}
                  >
                    Finalizados
                    <Badge bg="primary" className="ms-1 text-white">
                      {!Object.values(searchData).some(
                        (currentValue) => !!currentValue
                      )
                        ? professionalFinishedQuotesTotal
                        : professionalFinishedQuotesFoundTotal}
                    </Badge>
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="tab-content">
          <div
            id="pending-data-panel"
            role="tabpanel"
            aria-labelledby="pending-data"
            hidden={selectedNavTab !== "pending-data"}
          >
            <ProfessionalPendingQuoteList />
          </div>
          <div
            id="finished-data-panel"
            role="tabpanel"
            aria-labelledby="finished-data"
            hidden={selectedNavTab !== "finished-data"}
          >
            <ProfessionalFinishedQuoteList />
          </div>
        </div>
      </div>
    </ContainerAnimation>
  );
};

export default ProfessionalQuote;
